import React, { useState, useEffect } from "react";
import { FcGoogle } from "react-icons/fc";
import { SectionHeading } from "../UI/Card";

const reviews = [
  {
    name: "Amit Sharma",
    role: "6 reviews",
    rating: 5,
    content:
      "I booked a flight and hotel through Bachatwali Ticket and the experience was seamless! Everything was well-coordinated and support was top-notch.",
  },
  {
    name: "Neha Verma",
    role: "3 reviews 1 photo",
    rating: 5,
    content:
      "Highly recommend Bachatwali Ticket for last-minute bus bookings. Their platform is fast and easy to use. Customer support is very responsive.",
  },
  {
    name: "Rahul Mehta",
    role: "2 reviews",
    rating: 5,
    content:
      "Booked a hotel in Goa through Bachatwali Ticket — got the best price and smooth check-in. Loved the service!",
  },
  {
    name: "Priya Nair",
    role: "4 reviews",
    rating: 4,
    content:
      "Their flight booking system is super quick. Got amazing deals. Just wish they had more filter options, otherwise perfect!",
  },
  {
    name: "Rohit Sinha",
    role: "5 reviews 2 photos",
    rating: 5,
    content:
      "One of the best travel platforms I've used. Buses, flights, and hotels — all in one place. Keep it up Bachatwali Ticket!",
  },
];

const GoogleReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  const getInitials = (name) =>
    name
      .split(" ")
      .map((word) => word[0])
      .join("");

  const active = reviews[currentIndex];

  return (
    <section className="bg-ink-900 py-16">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6">
        <SectionHeading
          eyebrow="Testimonials"
          title="What people say about us"
          className="[&_h2]:text-white [&_p]:text-ink-300 mb-10"
        />

        <div className="flex items-center gap-2 mb-10">
          <FcGoogle className="w-9 h-9" />
          <span className="text-white font-semibold text-[15px]">Verified Customer Reviews</span>
          <div className="flex text-sun-accent ml-1">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="text-base leading-none">★</span>
            ))}
          </div>
        </div>

        <div className="relative max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-card p-6 sm:p-8 min-h-[13rem] flex flex-col justify-center">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-brand-50 text-brand-700 flex items-center justify-center text-base font-bold shrink-0">
                {getInitials(active.name)}
              </div>
              <div>
                <h4 className="font-bold text-ink-900 text-[15px]">{active.name}</h4>
                <div className="flex text-sun-accent">
                  {[...Array(active.rating)].map((_, i) => (
                    <span key={i} className="text-xs leading-none">★</span>
                  ))}
                </div>
              </div>
            </div>
            <p className="text-[15px] text-ink-600 leading-relaxed">{active.content}</p>
          </div>

          <button
            onClick={goToPrev}
            aria-label="Previous review"
            className="hidden sm:flex absolute -left-14 top-1/2 -translate-y-1/2 h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white hover:bg-brand-600 transition"
          >
            ❮
          </button>
          <button
            onClick={goToNext}
            aria-label="Next review"
            className="hidden sm:flex absolute -right-14 top-1/2 -translate-y-1/2 h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white hover:bg-brand-600 transition"
          >
            ❯
          </button>

          <div className="flex justify-center gap-1.5 mt-6">
            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Go to review ${index + 1}`}
                className={`h-2 rounded-full transition-all ${
                  index === currentIndex ? "w-6 bg-brand-500" : "w-2 bg-white/25"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
